// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__QsMJK","title":"Images90_title__2bN5F","images":"Images90_images__XN8BR"};